module.exports = __webpack_public_path__ + "static-v-shop/1761223296141/img/logo_maestro.ced7dab5.png";